import { useEffect } from 'react';
import { CheckCircle2, Info, XCircle, X } from 'lucide-react';
import { dismissToast, useAppDispatch, useAppSelector } from '@ui/store';
import { cn } from '@ui/lib/cn';

export function Toaster() {
  const toasts = useAppSelector((s) => s.ui.toasts);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const timers = toasts.map((t) => setTimeout(() => dispatch(dismissToast(t.id)), t.kind === 'error' ? 6000 : 3500));
    return () => timers.forEach(clearTimeout);
  }, [toasts, dispatch]);
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[60] flex w-[360px] max-w-[calc(100vw-2rem)] flex-col gap-2" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={cn('pointer-events-auto flex items-start gap-2.5 rounded-lg border bg-surface px-3.5 py-3 text-sm shadow-pop', t.kind === 'error' ? 'border-bad/30' : 'border-line')}>
          {t.kind === 'success' ? <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-good" /> : t.kind === 'error' ? <XCircle className="mt-0.5 h-4 w-4 shrink-0 text-bad" /> : <Info className="mt-0.5 h-4 w-4 shrink-0 text-info" />}
          <span className="flex-1 text-ink">{t.message}</span>
          <button className="text-muted hover:text-ink" onClick={() => dispatch(dismissToast(t.id))} aria-label="Dismiss">
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
